import React, { useState, useEffect } from 'react';
import './header.css';

const Header = () => {
  const [toggle, showMenu] = useState(false);
  const [activeNav, setActiveNav] = useState('#home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY >= 80);

      // Update active nav on scroll
      const sections = document.querySelectorAll('section[id], div[id]');
      const scrollPos = window.scrollY + 200;
      
      sections.forEach(section => {
        const top = section.offsetTop;
        const height = section.offsetHeight;
        const id = section.getAttribute('id');
        
        if (scrollPos >= top && scrollPos < top + height) {
          setActiveNav(`#${id}`);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (hash) => {
    setActiveNav(hash);
    showMenu(false);
  };

  const navItems = [
    { hash: '#about', label: 'About' },
    { hash: '#skills', label: 'Skills' },
    { hash: '#qualification', label: 'Education' },
    { hash: '#experience', label: 'Experience' },
    { hash: '#projects', label: 'Projects' },
    { hash: '#contact', label: 'Contact' },
  ];

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`} id="header">
      <nav className="nav container">
        <a href="#home" className="nav__logo" onClick={() => handleNavClick('#home')}>
          <span className="nav__logo-bracket">&lt;</span>
          <span className="nav__logo-text">HVS</span>
          <span className="nav__logo-bracket"> /&gt;</span>
        </a>

        <div className={`nav__menu ${toggle ? 'nav__menu--open' : ''}`}>
          <ul className="nav__list">
            {navItems.map((item) => (
              <li className="nav__item" key={item.hash}>
                <a
                  href={item.hash}
                  onClick={() => handleNavClick(item.hash)}
                  className={`nav__link ${activeNav === item.hash ? 'nav__link--active' : ''}`}
                >
                  <span className="nav__link-text">{item.label}</span>
                </a>
              </li>
            ))}
          </ul>

          <div className="nav__close" onClick={() => showMenu(false)}>
            <i className="uil uil-times"></i>
          </div>
        </div>

        <div className="nav__actions">
          <a href="#contact" className="nav__cta" onClick={() => handleNavClick('#contact')}>
            Let's Connect
          </a>
          <div className="nav__toggle" onClick={() => showMenu(!toggle)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;